
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Dialog from "@/components/UI/Dialog.vue";
import { getClipboardStatus } from "@/lib/copy-paste/utils";
import { ClipboardStatus } from "@/types/copy-paste";

@Component({ components: { Dialog } })
export default class ClipboardDialog extends Vue {
  @Prop()
  value!: boolean;

  status: ClipboardStatus | null = null;

  @Watch("value", { immediate: true })
  async onChange() {
    this.status = await getClipboardStatus();

    if (this.status?.permission)
      this.status.permission.onchange = () => {
        this.$emit("input", false);
      };
  }

  get permissionGranted() {
    return this.status?.permission?.state === "granted";
  }

  get metaKey() {
    return this.isAppleDevice ? "⌘" : "Ctrl + ";
  }

  get isAppleDevice() {
    return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  }

  close() {
    this.$emit("input", false);
  }
}
